import { useNavigate } from 'react-router-dom';

const WHATSAPP_NUMBER = '+923348872555';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}`;

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-[100dvh] flex items-end overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20modern%20high%20rise%20residential%20towers%20at%20golden%20hour%20dusk%20with%20green%20landscaping%20premium%20real%20estate%20development%20Islamabad%20Pakistan%20cinematic%20wide%20shot%20professional%20architecture%20photography%20warm%20amber%20lighting%204k&width=1920&height=1080&seq=301&orientation=landscape"
          alt="Premium Real Estate Development"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pb-12 md:pb-20 pt-28 md:pt-36">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#d4853a]/20 border border-[#d4853a]/30 text-[#f5c98a] text-xs md:text-sm font-medium mb-5">
            <i className="ri-award-line" />
            Pakistan's Premium Real Estate Investment Partner
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4">
            Find Your Perfect Property Investment With{' '}
            <span className="text-[#d4853a]">Sunshine Real Estate</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-xl">
            Residential plots, commercial opportunities, project marketing, and trusted consultation — all under one roof with complete transparency.
          </p>

          <div className="flex flex-wrap gap-3 mb-10">
            <button
              onClick={() => { navigate('/projects'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="px-6 py-3 bg-[#d4853a] text-white text-sm md:text-base font-semibold rounded-lg hover:bg-[#c27630] transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 whitespace-nowrap"
            >
              Explore Projects
            </button>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 border border-white/40 bg-white/10 backdrop-blur-sm text-white text-sm md:text-base font-semibold rounded-lg hover:bg-white/20 hover:border-white/60 transition-all duration-300 whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-whatsapp-line" />
              WhatsApp Consultation
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 border border-white/30 text-white text-sm md:text-base font-semibold rounded-lg hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
            >
              Book Site Visit
            </a>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap items-center gap-4 md:gap-6">
            <div className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
              <i className="ri-shield-check-fill text-[#4a9b5e] text-lg" />
              <span>Verified Projects</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
              <i className="ri-group-fill text-[#d4853a] text-lg" />
              <span>1,200+ Investors</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
              <i className="ri-star-fill text-[#d4853a] text-lg" />
              <span>98% Satisfaction</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}